import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { ApiClientConfig } from "../auth/ApiClientConfig";
import {
  UserProfileClient,
  type UserProvisioningResponse,
} from "../lib/ShiOneClient";

const api = new UserProfileClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT,
  axios,
);

async function fetchProvisioningData(): Promise<UserProvisioningResponse> {
  return api.getProvisioningData();
}

export function useProvisioningData() {
  return useQuery({
    queryKey: ["provisioning"],
    queryFn: fetchProvisioningData,
  });
}
